import { connect } from 'react-redux';
import ConsentRequestsList from "./ConsentRequestsList";
import {
    fetchGetOrganizationConsents,
    fetchGetOrganizationConsentsNextPage,
    loadingOrganizationConsents,
    getOrganizationConsentsData,
    isLoadNextPageAvailable
} from "../../../reducers/consent/organizationConsents";
import { getTranslation } from "../../../reducers/common/localization";
import { onChangeConsentRequestsFilterVisibility, getCurrentGroup } from "../../../reducers/account/role";

const mapStateToProps = state => {
    return {
        data: getOrganizationConsentsData(state),
        departmentId: getCurrentGroup(state),
        loading: loadingOrganizationConsents(state),
        isLoadNextPageAvailable: isLoadNextPageAvailable(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetOrganizationConsents());
            dispatch(onChangeConsentRequestsFilterVisibility(true));
        },
        onUnmount: () => {
            dispatch(onChangeConsentRequestsFilterVisibility(false));
        },
        onGetConsentRequests: () => dispatch(fetchGetOrganizationConsents()),
        onGetConsentRequestsNextPage: () => dispatch(fetchGetOrganizationConsentsNextPage())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsentRequestsList);



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/consentRequestsList/ConsentRequestsList.container.js